import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance2xdbr0bdtxbh1 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.p5x_1 = call;
        this.q5x_1 = responseData.o5j_1;
        this.r5x_1 = responseData.j5j_1;
        this.s5x_1 = responseData.m5j_1;
        this.t5x_1 = responseData.k5j_1;
        this.u5x_1 = responseData.p5j_1;
        var tmp = this;
        var tmp_0 = responseData.n5j_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.v5x_1 = tmp0_elvis_lhs == null ? Companion_getInstance().u4j_1 : tmp0_elvis_lhs;
        this.w5x_1 = responseData.l5j_1;
      }
      g5i() {
        return this.p5x_1;
      }
      ew() {
        return this.q5x_1;
      }
      p5i() {
        return this.r5x_1;
      }
      q5i() {
        return this.s5x_1;
      }
      r5i() {
        return this.t5x_1;
      }
      s5i() {
        return this.u5x_1;
      }
      o5i() {
        return this.v5x_1;
      }
      a50() {
        return this.w5x_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
